import { UPDATE_VOUCHER_OBJECT } from '../actions/ActionsConstants';

const initialState = {
    code: '',
    percentage: ''
};

export default function voucher(state = initialState, action) {
    switch (action.type) {
        case UPDATE_VOUCHER_OBJECT:
            return { ...state, code: action.value.code, percentage: action.value.percentage };
        default:
            return state;
    }
}
